import React, { FC } from "react";

import useScreenSize from "@app/hooks/useScreenSize";

interface ResponsiveImageProps {
  mobileSrc: string;
  desktopSrc: string;
  alt: string;
  className?: string;
}

const minDesktopWidth = 768;

const ResponsiveImage: FC<ResponsiveImageProps> = ({
  alt,
  className,
  mobileSrc,
  desktopSrc,
}) => {
  const { screenWidth } = useScreenSize();

  const imageResourceLink = (mobileSrc: string, desktopSrc: string): string => {
    if (screenWidth < minDesktopWidth) {
      return mobileSrc;
    }
    return desktopSrc;
  };

  return (
    <img
      src={imageResourceLink(mobileSrc, desktopSrc)}
      alt={alt}
      className={className}
    ></img>
  );
};

export default ResponsiveImage;
